import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Toolbar, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { CommonInformationDialogReduerAction } from "../Store/dialog/CommonInformationDialogReduer";

const CommonInformationDialog = () => {

  const dispatch = useDispatch();

  const dialogHeader = useSelector(
    (state) => state.commonInfoDialogReduer.dialogHeader
  );
  const dialogText = useSelector(
    (state) => state.commonInfoDialogReduer.dialogText
  );
  const dialogOpen = useSelector(
    (state) => state.commonInfoDialogReduer.dialogOpen
  );

    return (
          <Dialog
            maxWidth= "sm"
            fullWidth
            open={dialogOpen}
          >
            <DialogTitle>{dialogHeader}</DialogTitle>
            <DialogContent>
              <DialogContentText  id="alert-dialog-description"
                 sx={{ wordBreak: "break-word", wordWrap: "break-word" }}>
                   {dialogText}
               </DialogContentText>
            </DialogContent>
            <Box sx={{display: "flex", justifyContent: "center"}}>
              <DialogActions>
                <Button variant="contained" onClick={() => {
                  dispatch(CommonInformationDialogReduerAction.updateDialogOpen(false));
                }}> OK </Button>
              </DialogActions>
            </Box>
            </Dialog>
);
}

export default CommonInformationDialog;